﻿import { ensureJQuery, ensureParsley, ensureInputmask } from "@js/core/loaders/vendors";
import { onlyDigits } from "@js/core/utils/text";
import { initIdentityMask, initOrderMask } from "@js/core/forms/masking";
import {
    initParsleyLocale,
    registerCommonValidators,
    initParsleyForm
} from "@js/core/forms/parsley";
import { initTiltCards } from "@js/core/motion/tilt-card";
import { currentLang } from "@js/core/utils/i18n";

function initFormAttributes() {
    const identity = document.getElementById("IdentityNumber");
    const order = document.getElementById("OrderNumber");

    if (identity) {
        identity.setAttribute("data-parsley-vkn-or-tckn", "true");
    }

    if (order) {
        order.setAttribute("data-parsley-validate-if-empty", "true");
    }
}

function initOptionalOrderLogic() {
    if (!window.jQuery) return;

    const $ = window.jQuery;

    $("#OrderNumber").on("input", function () {
        const val = onlyDigits($(this).val());

        if (val.length === 0) {
            $(this).removeAttr("data-parsley-pattern");
        } else {
            $(this).attr("data-parsley-pattern", "^\\d{5}$");
        }
    });
}

function initSubmitState() {
    if (!window.jQuery) return;

    const $ = window.jQuery;
    const $form = $("#virtualPosForm");
    const $submit = $("#virtualPosSubmitBtn");

    if (!$form.length || !$submit.length) return;

    $form.on("submit", function (e) {
        const parsley = $form.parsley();

        if (!parsley.isValid()) {
            e.preventDefault();
            parsley.validate();
            return false;
        }

        $submit.addClass("is-loading");
        $submit.prop("disabled", true);

        return true;
    });
}

export async function initVirtualPosLogin() {
    const form = document.getElementById("virtualPosForm");
    if (!form) return;

    await ensureJQuery();
    await ensureInputmask();
    await ensureParsley(currentLang());

    initIdentityMask(".js-vkn-tckn");
    initOrderMask(".js-order-no");

    initParsleyLocale(currentLang());
    registerCommonValidators();
    initFormAttributes();
    initParsleyForm("#virtualPosForm");

    initOptionalOrderLogic();
    initSubmitState();

    initTiltCards(".credit-card", {
        maxRotateX: 4,
        maxRotateY: 5,
        perspective: 1200,
        baseRotate: 0
    });
}